/**
 * TypeBox schemas for LayerGroup entity
 *
 * NOTE: This file currently contains the LEGACY schema with tripId, layerType,
 * parentLayerId, etc. These fields are replaced by edges in the new graph model.
 * The schema will be simplified in Phase 3 when layer-group-manager is migrated.
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, HexColor, type Exact } from './common.js'

/** @deprecated LayerType is replaced by edge-based relationships */
export const LayerTypeSchema = Type.Union([
  Type.Literal('trip'),
  Type.Literal('tracks'),
  Type.Literal('features'),
  Type.Literal('custom'),
])
export type LayerType = Static<typeof LayerTypeSchema>

export const LayerGroupSchema = Type.Object({
  id: UUID,
  name: Type.String({ minLength: 1, maxLength: 100 }),
  description: Type.Optional(Type.String({ maxLength: 500 })),
  color: HexColor,
  icon: Type.Optional(Type.String({ minLength: 1, maxLength: 50 })),
  layerType: LayerTypeSchema,
  isSystemGroup: Type.Boolean(),
  parentLayerId: Type.Optional(UUID),
  tripId: Type.Optional(UUID),
  displayOrder: Type.Number({ minimum: 0 }),
  isVisible: Type.Boolean(),
  isExpanded: Type.Boolean(),
  featureIds: Type.Array(UUID),
  createdAt: ISODate,
  updatedAt: ISODate,
  createdBy: UUID,
})
export type LayerGroup = Exact<Static<typeof LayerGroupSchema>>

/** Fields required when creating a layer group */
export const LayerGroupCreateSchema = Type.Object({
  name: Type.String({ minLength: 1, maxLength: 100 }),
  color: HexColor,
  isSystemGroup: Type.Boolean(),
  displayOrder: Type.Number({ minimum: 0 }),
  isVisible: Type.Boolean(),
  isExpanded: Type.Boolean(),
  featureIds: Type.Array(UUID),
  createdBy: UUID,
})

/** Partial layer group for updates */
export const LayerGroupUpdateSchema = Type.Partial(LayerGroupSchema)
